import type { TColor } from '@Anarchy/Engine/Color';
import { serializeColor } from '@Anarchy/Engine/Color';
import { extractSerializableRegistrableFields } from '@Anarchy/Engine/Mixins';
import type { TSceneConfig, TSceneWrapper } from '@Anarchy/Engine/Scene/Models';
import { filterOutEmptyFields, isDefined } from '@hellpig/anarchy-shared/Utils';

export function sceneEntityToConfig(entity: TSceneWrapper): TSceneConfig {
  const background: TColor | undefined = entity.getBackground() as TColor | undefined;
  // TODO we cannot serialize other backgrounds than Color at the moment
  const hexString: string | undefined = isDefined(background) && background.isColor ? serializeColor(background) : undefined;

  return filterOutEmptyFields({
    background: hexString,
    isActive: entity.isActive(),
    ...extractSerializableRegistrableFields(entity)
  });
}
